import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ServiceOrder } from '@secca/shared/models/service-order/service-order';
import { ServiceOrderHoverExtensionComponent } from '../service-order-hover-extension-component';
import { StakeholderTypeEnum, StatusTypes } from '@secca/shared/models/enums';
import { CaseStakeholder } from '@secca/shared/models/caseStakeholder';
import { StakeholderService } from '@secca/core/services/stakeholder.service';
import { CoordinationTransportServiceOrderExtension } from '@secca/shared/models/service-order/coordination-transport-service-order-extension';
import { ICCStakeholder } from '../../../case-plans/add-service-order/models/icc-stakeholder';

@Component({
    selector: 'app-coordination-transport-service-order-hover',
    templateUrl: './coordination-transport-service-order-hover.component.html',
    styleUrls: ['./coordination-transport-service-order-hover.component.scss'],
    standalone: false
})
export class CoordinationTransportServiceOrderHoverComponent  implements ServiceOrderHoverExtensionComponent , OnChanges, OnInit   {

  @Input() serviceOrder: ServiceOrder;
  @Input() providerName: string;
  @Input() agentName: string;
  @Input() linkedCasesStakeholders: CaseStakeholder[];
  servideOrderStakeholders: ICCStakeholder[];
  displayStakeholder: CaseStakeholder[] = [];
  coordinationTransportServiceOrderExtension: CoordinationTransportServiceOrderExtension;
  stakeholders: { firstName: string; surname: string; icon: string; gender: string; age: string }[];

  constructor(private stakeholderService: StakeholderService){ }


  ngOnInit() {
    this.coordinationTransportServiceOrderExtension = this.serviceOrder.extension as CoordinationTransportServiceOrderExtension;
    this.servideOrderStakeholders =  this.serviceOrder.status === StatusTypes.EXPECTED ? this.coordinationTransportServiceOrderExtension.iccExpectedFlightStakeholders.stakeholders : this.coordinationTransportServiceOrderExtension.iccConfirmationFlightStakeholders.stakeholders;
    this.servideOrderStakeholders.forEach(stakeholder => {
      const caseStakeholder = this.linkedCasesStakeholders.find(a => a.id === stakeholder.stakeholderId);
      if (caseStakeholder != null) {
        this.displayStakeholder.push(this.createLocalStakeholder(caseStakeholder));
      }
    });
   }

   ngOnChanges() { }

   onRefresh() {  }

    get statusType(): string {
      switch (this.serviceOrder.status) {
        case StatusTypes.CANCELLED:
          return 'service-order-cancelled';
        case StatusTypes.COMMITTED:
          return 'service-order-committed';
        case StatusTypes.EXPECTED:
          return 'service-order-expected';
        case StatusTypes.NOT_COVERED:
          return 'service-order-not-covered';
        case StatusTypes.PARTIALLY_COMMITTED:
          return '';
      }
    }

    getStartTimeZone(): string {
      return this.serviceOrder.getStartLocation() ? this.serviceOrder.getStartLocation().timeZoneId : 'local';
    }

    getStartCountry(): string {
      return this.serviceOrder.getStartLocation() ? this.serviceOrder.getStartLocation().country : 'Denmark';
    }

    private createLocalStakeholder(caseStakeholder: CaseStakeholder): any {
      let type = caseStakeholder.stakeholderType;
      if (caseStakeholder.coTraveller) {
        type = StakeholderTypeEnum.coTraveller;
      }
      let name = '';
      if (caseStakeholder.isCompany) {
        name = caseStakeholder.company?.name;
      } else {
        name = caseStakeholder.person?.firstName + ' ' + caseStakeholder.person?.surname;
      }
      return {
        name,
        icon: this.stakeholderService.getStakeholderIconFullPath(type),
        gender: caseStakeholder.person?.gender,
        age: caseStakeholder.person?.age,
      };
    }
}
